// extracted by mini-css-extract-plugin
module.exports = {"headerImg":"UnpaidPurchase_headerImg__1V7lb"};